/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AptosHourScheduleControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateNode(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/hour/node/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateDelegationNode(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/hour/node/delegation/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateMemeCoinPrice(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/hour/meme/coin/price/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public deleteMemeCoinPrice({
        subtract = 25,
        unit = 'Hours',
    }: {
        subtract?: number,
        unit?: 'Nanos' | 'Micros' | 'Millis' | 'Seconds' | 'Minutes' | 'Hours' | 'HalfDays' | 'Days' | 'Weeks' | 'Months' | 'Years' | 'Decades' | 'Centuries' | 'Millennia' | 'Eras' | 'Forever',
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/hour/meme/coin/price/delete',
            query: {
                'subtract': subtract,
                'unit': unit,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateMemeCoinMView(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/hour/meme/coin/mview/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public defiProtocolListUpdate(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/hour/defi/protocol/list/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updatePoolYield(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/hour/defi/pool/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateCoinPrice3(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/hour/coin/price/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public addNewCoinPriceList(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/hour/coin/price/list/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateCmcCoinPrice(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/hour/cmc/coin/price/update',
        });
    }

}
